import React, { useEffect, useRef } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError } from '../../components';
import css from './FieldRichTextInput.module.css';

const FieldRichTextInputComponent = props => {

  if (typeof window == 'undefined') {
    return null;
  }

  const ReactQuill = require('react-quill');
  require('react-quill/dist/quill.snow.css');


  const {
    rootClassName,
    className,
    id,
    label,
    input,
    meta,
    customErrorText,
    hideErrorMessage,
    ...rest
  } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { touched, invalid, error } = meta;
  const errorText = customErrorText || error;
  const hasError = !!customErrorText || !!(touched && invalid && error);
  const fieldMeta = { touched: hasError, error: errorText };

  const classes = classNames(rootClassName || css.root, className);

  const quillRef = useRef();

  // Set paragraph as default format
  useEffect(() => {
    if (quillRef.current && quillRef.current.getEditor) {
      const editor = quillRef.current.getEditor();
      editor.format('header', false);
    }
  }, []);

  return (
    <div className={classes}>
      {label ? <label htmlFor={id} className={css.label}>{label}</label> : null}

      {/* Custom toolbar */}
      <div id="custom-toolbar">
        <select className="ql-header" defaultValue="">
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option value="">Paragraph</option>
        </select>
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        {/* <select className="ql-align" /> */}
      </div>

      <ReactQuill
        ref={quillRef}
        id={id}
        className={css.richTextEditor}
        theme="snow"
        value={input.value || ''}
        onChange={input.onChange}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        {...rest}
        modules={{
          toolbar: '#custom-toolbar'
        }}
        formats={FieldRichTextInputComponent.formats}
      />

      {hideErrorMessage ? null : <ValidationError fieldMeta={fieldMeta} />}
    </div>
  );
};

FieldRichTextInputComponent.formats = [
  'header', 'bold', 'italic', 'underline'
];

const FieldRichTextInput = props => <Field component={FieldRichTextInputComponent} {...props} />;

export default FieldRichTextInput;
